import React, { Component } from 'react';
import * as validators from 'utils/validators';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import InputField from 'components/InputField';
import RichField from 'components/RichField';
import ShopifyLocationsSelectField from 'components/ShopifyLocationsField';

class EmailTranslation extends Component {

    render() {
        let { el, translation, idx, onClick } = this.props;

        return (<div>
            <h4 style={{ textAlign: "right" }}>#{idx + 1}{" "}<i className="fa fa-times-circle location-panel-remove" title="Remove location" onClick={onClick}></i></h4>
            <div className="form-group">
                <label htmlFor={`${el}.subject`}>Subject{' '} </label>

                <Field
                    className="form-control"
                    name={`${el}.subject`}
                    component={InputField}
                    type="text"
                    defaultValue = {translation.subject}
                    validate={[validators.required]}
                />
            </div>
            <div className="form-group">
                <label htmlFor={`${el}.template`}>Body</label>
                <Field
                    name={`${el}.template`}
                    component={RichField}
                    showParameters={true}
                    html={translation.template}
                />
            </div>
            <div className="form-group">
                <label htmlFor={`${el}.locationId`}>Location</label>
                <Field id={`${el}.locationId`} name={`${el}.locationId`} value={translation.locationId} component={ShopifyLocationsSelectField} validate={[validators.required]} />
            </div>
        </div>);
    }
}


export default EmailTranslation;


// WEBPACK FOOTER //
// app/containers/EmailTranslation.jsx